import ctl from '@netlify/classnames-template-literals';

const listContainer = ctl(`
  flex-1
  rounded-lg 
  overflow-y-auto
  bg-white
  max-h-40
`);

const listStyle = ctl(`
  list-none 
  p-0 
  m-0 
  h-auto
`);

export default {
  listContainer,
  listStyle,
};
